var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "87.814 50.211 97.379 111.289",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.37 50.2106C161.217 50.2106 164.325 53.3188 164.325 57.1661V64.1217H171.281C178.954 64.1217 185.192 70.36 185.192 78.0329V140.633C185.192 148.306 178.954 154.544 171.281 154.544H101.725C94.0522 154.544 87.814 148.306 87.814 140.633V78.0329C87.814 70.36 94.0522 64.1217 101.725 64.1217H108.681V57.1661C108.681 53.3188 111.789 50.2106 115.636 50.2106C119.484 50.2106 122.592 53.3188 122.592 57.1661V64.1217H150.414V57.1661C150.414 53.3188 153.522 50.2106 157.37 50.2106ZM162.152 85.358C159.826 83.6625 156.565 84.1842 154.87 86.51L128.917 122.201L117.593 110.876C115.549 108.833 112.245 108.833 110.224 110.876C108.202 112.919 108.181 116.223 110.224 118.245L125.874 133.895C126.961 134.982 128.461 135.525 129.96 135.416C131.46 135.308 132.873 134.525 133.764 133.286L163.304 92.6396C164.999 90.3138 164.477 87.0534 162.152 85.358Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsActive);
export default __webpack_public_path__ + "static/media/appointments-active.d5eaedb734dba5ea3f734ad5850a10bc.svg";
export { ForwardRef as ReactComponent };